import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { addMinutes } from "date-fns";
import { FormProvider, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { getTimeZonedDate } from "shared/helpers";
import { useAsyncDispatch } from "shared/helpers/hooks/useAsyncDispatch";
import { emailRegex } from "shared/helpers/validators";
import ButtonLoader from "shared/ui/ButtonLoader";
import RightDrawer from "shared/ui/Drawer";
import BasicSelect from "shared/ui/Select";
import InputField from "shared/ui/TextInput";
import { EDistributionMethods } from "store/enums/campaignDetails";
import { ERequestStatus } from "store/enums/index.enum";
import { ICreateOneTimeTrigger } from "store/interfaces/customers";
import { selectCampaignTranslations } from "store/slicers/campaignTranslations";
import {
  selectButtonLoadingState,
  setButtonLoading,
} from "store/slicers/common";
import { CreateOneTimeTrigger } from "store/slicers/customers";

const TestEmail = ({ isSendEmailOpen, setSendEmailOpen, t, surveyID }) => {
  const dispatch = useAsyncDispatch();
  const languages = useSelector(selectCampaignTranslations);
  const methods = useForm({
    defaultValues: {
      contacts: "",
      language_id: languages?.displayData?.[0]?.languageID || "",
    },
    mode: "onChange",
  });
  const { handleSubmit, watch } = methods;
  const isButtonLoading = useSelector(selectButtonLoadingState);

  const sendEmail = async (formData) => {
    dispatch(setButtonLoading(true));
    const scheduleTime = getTimeZonedDate(addMinutes(new Date(), 1));

    const splitted = formData?.contacts?.split(",").map((item) => item.trim());

    const allValid = splitted?.every((email) => emailRegex.test(email));
    if (!allValid) {
      toast.error(t("please_enter_valid_emails"));
      dispatch(setButtonLoading(false));
      return;
    }
    const data = splitted.map((item) => {
      return {
        phoneNumber: "",
        customerName: "",
        email: item,
        customerSurname: "",
        serviceType: "",
        languageID: formData?.language_id,
      };
    });

    const requestData: ICreateOneTimeTrigger = {
      campaignID: Number(surveyID),
      data,
      scheduleTime,
      ignoreQuarantine: true,
      distributionMethod: EDistributionMethods.Email,
    };

    const { meta } = await dispatch(CreateOneTimeTrigger(requestData));
    if (meta.requestStatus !== ERequestStatus.FULFILLED) {
      dispatch(setButtonLoading(false));
      return;
    }

    toast.success(t("email_sent_successfully"));
    setSendEmailOpen(false);
    dispatch(setButtonLoading(false));
  };
  return (
    <FormProvider {...methods}>
      <RightDrawer
        open={isSendEmailOpen}
        setOpen={() => setSendEmailOpen(false)}
        title={t("test_email")}
      >
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              "& textarea": {
                paddingTop: "25px",
              },
            }}
          >
            <InputField
              name={"contacts"}
              label={"Emails"}
              multiline
              placeholder="test@mail.ru, test.gmail.com"
            />
          </Box>

          <BasicSelect
            options={languages?.displayData}
            label={"language"}
            name={"language_id"}
            labelProp="language"
            valueProp="languageID"
          />
          <ButtonLoader
            fullWidth
            onClick={handleSubmit(sendEmail)}
            isLoading={isButtonLoading}
            disabled={!watch("contacts")}
            type="submit"
          >
            <Typography>{t("send")}</Typography>
          </ButtonLoader>
        </Box>
      </RightDrawer>
    </FormProvider>
  );
};

export default TestEmail;
